import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { browserUtils } from '../../utils'
import alertIcon from '../../assets/icons/alert-circle.svg'
import thumbsUp from '../../assets/icons/thumbs-up.svg'
import thumbsDown from '../../assets/icons/thumbs-down.svg'
import thumbsUpFilled from '../../assets/icons/thumbs-up-filled-in.svg'
import thumbsDownFilled from '../../assets/icons/thumbs-down-filled-in.svg'
import './ReviewForm.sass'


const INITIAL_STATE = {
  review: {
    value: '',
    isValid: false
  },
  name: {
    value: '',
    isValid: false
  },
  isUpvote: true,
  submitAttempted: false,
  isSubmitting: false,
  isServerError: false
}

class ReviewForm extends Component {
  state = INITIAL_STATE

  constructor() {
    super()
    this._validateAndSubmit = this.validateAndSubmit.bind(this)
    this._updateReviewText = this.updateReviewText.bind(this)
    this._updateName = this.updateName.bind(this)
    this._resetForm = this.resetForm.bind(this)
  }

  componentDidMount() {
    if (!browserUtils.isMobileOrTabletDevice()) {
      this.nameInput.focus()
    }
  }

  resetForm() {
    this.setState(INITIAL_STATE)
  }

  validateAndSubmit(e) {
    e.preventDefault()

    const { name, review, isUpvote } = this.state
    const { toolId, submitReview, toggleReviewOverlay } = this.props

    if (name.isValid && review.isValid) {
      // Submit review
      const reviewData = {
        name: name.value,
        review: review.value,
        isUpvote
      }

      this.setState({ isSubmitting: true })

      // Call redux action, then close modal (on success) or display message (on error)
      submitReview(toolId, reviewData)
        .then(res => {
          this._resetForm()
          toggleReviewOverlay()  // close modal
        })
        .catch(err => {
          this.setState({ isSubmitting: false, isServerError: true, submitAttempted: true })
        })
    } else {
      // Invalid form
      this.setState({ submitAttempted: true })
    }
  }

  updateReviewText(e) {
    const text = e.target.value
    const newReview = {
      value: text,
      isValid: text.trim().length >= 10 && text.trim().length < 1000
    }

    this.setState({ review: newReview })
  }

  updateName(e) {
    const newName = {
      value: e.target.value,
      isValid: e.target.value.trim().length >= 1
    }

    this.setState({ name: newName })
  }

  updateVote(isUpvote) {
    this.setState({ isUpvote })
  }

  renderErrorMsgs(isNameValid, isReviewValid, isServerError) {
    return (
      <div className="error-msgs">
        { !isNameValid && <p className="error-msg"><img src={alertIcon} alt="alert" />Please enter a name</p> }
        { !isReviewValid && <p className="error-msg"><img src={alertIcon} alt="alert" />Review must contain between 10 and 1000 characters</p> }
        { isServerError && <p className="error-msg"><img src={alertIcon} alt="alert" />Server error</p>}
      </div>
    )
  }

  render() {
    const { review, name, isUpvote, submitAttempted, isSubmitting, isServerError } = this.state

    return (
      <form className="review-form review-overlay-form" onSubmit={this._validateAndSubmit}>
        <h4 className="center">Write your review</h4>
        <div className="icon-selector">
          <button type="button" aria-label="up vote" onClick={() => this.updateVote(true)}>
            <img src={isUpvote ? thumbsUpFilled : thumbsUp} alt="thumbs up" />
          </button>
          &nbsp;&nbsp;<span>OR</span>&nbsp;&nbsp;
          <button type="button" aria-label="down vote" onClick={() => this.updateVote(false)}>
            <img src={isUpvote ? thumbsDown : thumbsDownFilled} alt="thumbs down" />
          </button>
        </div>
        <fieldset>
          <label htmlFor="name">Your name</label>
          <input
            type="name"
            placeholder="Type your name..."
            name="name"
            value={name.value}
            onChange={this._updateName}
            ref={input => this.nameInput = input}
          />
          <label htmlFor="review">Review</label>
          <textarea
            placeholder="Type your review..."
            name="review"
            maxLength="1000"
            value={review.value}
            onChange={this._updateReviewText}
          />
        </fieldset>
        <button
          type="submit"
          className="btn-transparent"
          disabled={isSubmitting}
        >
          post
        </button>
        { submitAttempted && this.renderErrorMsgs(name.isValid, review.isValid, isServerError) }
      </form>
    )
  }
}

ReviewForm.propTypes = {
  submitReview: PropTypes.func.isRequired,
  toolId: PropTypes.number,
  toggleReviewOverlay: PropTypes.func
}

export default ReviewForm
